/* eslint-disable max-len */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unsafe-optional-chaining */
import {useState, useEffect, useRef} from 'react';
import {
  Button,
  Form,
  Input,
  message,
  Spin,
  Tabs,
  List,
  Card,
  Row,
  Col,
  Table,
  Checkbox,
  notification,
} from 'antd';
import useCommon from '@utils/hooks/common';
import MainThemeButton from '@components/MainThemeButton';
import {
  GAME_MODE,
  TIME_DIFFERENCE_CHECK_COUNT,
  TIME_DIFFERENCE_THRESHOLD,
  getLobbyEvent,
} from '@constant/game';
import {useRouter} from 'next/router';
import useRequest from '@utils/hooks/useRequestCustom';
import {CURRENCIES, TABLET_BREAKPOINT} from '@constant/system';
import bannerApi from '@utils/api/banner.api';
import {env} from 'next-runtime-env';
import Link from 'next/link';
import styles from './styles';
import Slider from 'react-slick';
import Head from 'next/head';
import TalkBubble from '@components/talk-bubble';
import BlackButton from '@components/home/BlackButton';
import GoldenButton from '@components/home/GoldenButton';
import GoldenDIvider from '@components/GoldenDivider';
import {GameLogicInterface} from 'poker-interfaces';
import userApi from '@utils/api/user.api';
import {getFailRedirectUrl, handleJoinRoom} from '@utils/index';
import announcementApi from '@utils/api/announcements.api';
import NewCustomizedModal from '@components/NewCustomizedModal';
import {getInternetTime, getMachineTime} from '@utils/api/getTime.api';
import authApi from '@utils/api/auth.api';
import CustomInput from '@components/CustomInput';
// import LiveTable from '@components/home/LiveTable';
import HomeCardItem from '@components/home/HomeCardItem';
import {Skeleton} from 'antd-mobile';
// import EnterRoomModalSheet from '@components/home/EnterRoomModalSheet';
// import RoomSettingModalSheet from '@components/home/RoomSettingModalSheet';

import dynamic from 'next/dynamic';
import {useDebugView} from '@utils/hooks/debug';
import {TonConnectButton} from '@tonconnect/ui-react';
import CustomPopup from '@components/CustomPopup';
import GradientButton from '@components/GradientButton';
import gameApi from '@utils/api/game.api';
import {isTelegramMiniApp} from '@components/layout';
import {getTabBubbleRefForRoom} from '@utils/tabBubbleRefs';
import {autorun, toJS} from 'mobx';
import useIsMobile from '@utils/hooks/useIsMobile';

const LiveTable = dynamic(() => import('@components/home/LiveTable'), {
  ssr: false,
});

const EnterRoomModalSheet = dynamic(() => import('@components/home/EnterRoomModalSheet'), {
  ssr: false,
});

const RoomSettingModalSheet = dynamic(() => import('@components/home/RoomSettingModalSheet'), {
  ssr: false,
});

const {useForm} = Form;

const NEXT_PUBLIC_URL = env('NEXT_PUBLIC_URL');

const ONE_DAY_IN_MILLISECONDS = 86400000;

const Home = () => {
  const {classes, t, user, socket, system, lobbySocket, theme} = useCommon({
    withTranslation: ['home'],
    withStyles: styles,
    observers: ['socket', 'user', 'system', 'lobbySocket', 'game', 'lucky_draw'],
  });

  const router = useRouter();
  const isDebugView = useDebugView();
  const {query} = router;
  const referralCode = query?.ref;

  enum MODAL_TYPE {
    CREATE_OR_ENTER,
    GAME_TYPE,
    ENTER_CODE,
  }
  const isMobile = useIsMobile();

  const [form] = useForm();
  // const [isFirstTimeLoginVisible, setIsFirstTimeLoginVisible] = useState<boolean>(false);
  const [isRoomSettingDrawerVisible, setIsRoomSettingDrawerVisible] = useState<boolean>(false);
  const [gameTypeSelected, setGameTypeSelected] = useState<GameLogicInterface.GameType>('REGULAR');
  const [modalType, setModalType] = useState<MODAL_TYPE>(null);
  const [roomCode, setRoomCode] = useState('');
  const isDesktop = theme?.currentStyleFormat?.id === 'desktop';

  const [isAnnouncementVisible, setIsAnnouncementVisible] = useState<boolean>(false);
  const [internetTime, setInternetTime] = useState<Date | null>(null);
  const [machineTime, setMachineTime] = useState<Date | null>(null);
  const [timeDifference, setTimeDifference] = useState<number | null>(null);
  const [isTimeDifferenceModalVisible, setIsTimeDifferenceModalVisible] = useState<boolean>(false);
  // const [consecutiveThresholdBreaches, setConsecutiveThresholdBreaches] = useState<number>(0);
  const [isLuckyDrawReminderVisible, setIsLuckyDrawReminderVisible] = useState<boolean>(false);
  const [hasLuckyDrawReminderDisplayed, setHasLuckyDrawReminderDisplayed] =
    useState<boolean>(false);
  const [numOfDraws, setNumOfDraws] = useState<number>(0);

  const [displayName, setDisplayName] = useState<string>('');
  const [isDisplayNamePopupVisible, setIsDisplayNamePopupVisible] = useState<boolean>(false);

  const {
    data: announcementList,
    loading: isAnnouncementLoading,
    runAsync: getAnnouncementList,
  } = useRequest(token => announcementApi.getAnnouncementList(user?.getPlayerToken()), {
    manual: true,
  });

  const {data: wheelItemData, loading: wheelItemLoading} = useRequest(gameApi.getLuckyDrawInfo, {
    initialData: null,
  });

  const {runAsync: getNumOfDraws, loading: numOfDrawsLoading} = useRequest(gameApi.getNumOfDraws, {
    manual: true,
    onError: (err: Error) => {
      notification.error({message: t('get_num_of_draws_failed')});
    },
  });

  const slider = useRef(null);

  const sessionLuckyDrawReminder = sessionStorage.getItem('hasLuckyDrawReminderDisplayed');

  useEffect(() => {
    const showLuckyDrawReminder = async () => {
      // console.log('not show reminder', localStorage.getItem('notShowLuckyDrawReminderAgain'));
      if (
        user?.isLogin() &&
        wheelItemData &&
        // !hasLuckyDrawReminderDisplayed &&
        localStorage.getItem('notShowLuckyDrawReminderAgain') !== 'true' &&
        sessionLuckyDrawReminder !== 'true'
      ) {
        const wheelId = wheelItemData?.data?.wheels[0]?.wheelId;
        const numOfDraws = await getNumOfDraws(user?.getPlayerToken(), wheelId);
        if (numOfDraws?.data?.availableDraws > 0) {
          setNumOfDraws(numOfDraws?.data?.availableDraws);
          // setIsLuckyDrawReminderVisible(true);
          // setHasLuckyDrawReminderDisplayed(true);
          sessionStorage.setItem('hasLuckyDrawReminderDisplayed', 'true');
          notification.open({
            key: 'lucky-draw',
            message: t('lucky_draw_reminder.message', {value: numOfDraws?.data?.availableDraws}),
            description: (
              <Button
                // * style will be gone if css is used
                style={{
                  margin: '0px',
                  height: 30,
                  padding: '0 10px',
                  borderRadius: 10,
                  color: 'white',
                  border: 'none',
                  background: 'linear-gradient(90deg, #33C4E8 0%, #4A65F2 100%)',
                  boxShadow:
                    '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.25) inset',
                  '&.ant-btn:hover, &.ant-btn:focus, &.ant-btn:active': {
                    background: 'linear-gradient(90deg, #33C4E8 0%, #4A65F2 100%)',
                    boxShadow:
                      '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.25) inset',
                    filter: 'brightness(1.2)',
                    border: 'none',
                    color: 'white',
                  },
                  '&.ant-btn[disabled]': {
                    background: 'linear-gradient(90deg, #33C4E8 0%, #4A65F2 100%)',
                    boxShadow:
                      '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.25) inset',
                    filter: 'brightness(0.5)',
                    border: 'none',
                    color: 'white',
                  },
                }}
                onClick={() => {
                  router.push('/fortune-wheel');
                  notification.destroy('lucky-draw');
                }}
              >
                {t('lucky_draw_reminder.spin_now')}
              </Button>
            ),
          });
        }
      }
    };

    showLuckyDrawReminder();
  }, [wheelItemData, user, sessionLuckyDrawReminder]);

  // useEffect(() => {
  //   getInternetTime().then(ntpTime => setInternetTime(ntpTime));
  //   setMachineTime(getMachineTime());
  // }, []);

  // useEffect(() => {
  //   if (
  //     internetTime &&
  //     machineTime &&
  //     consecutiveThresholdBreaches <= TIME_DIFFERENCE_CHECK_COUNT
  //   ) {
  //     const difference = internetTime.getTime() - machineTime.getTime();
  //     setTimeDifference(difference);
  //     if (Math.abs(difference) > TIME_DIFFERENCE_THRESHOLD) {
  //       setConsecutiveThresholdBreaches(prevCount => prevCount + 1);
  //     } else {
  //       setConsecutiveThresholdBreaches(0);
  //     }
  //   }
  // }, [internetTime, machineTime, consecutiveThresholdBreaches]);

  // useEffect(() => {
  //   if (consecutiveThresholdBreaches === TIME_DIFFERENCE_CHECK_COUNT) {
  //     // setIsTimeDifferenceModalVisible(true);
  //   }
  // }, [consecutiveThresholdBreaches]);

  useEffect(() => {
    const lastShown = localStorage.getItem('modalLastShown');

    if (announcementList?.length === 0 || typeof announcementList === 'undefined') return;
    if (
      (!lastShown || Date.now() - parseInt(lastShown, 10) >= ONE_DAY_IN_MILLISECONDS) &&
      !system.isGameOverlayShown
    ) {
      setIsAnnouncementVisible(true);
      localStorage.setItem('modalLastShown', Date.now().toString());
    }
  }, [system.isGameOverlayShown]);

  useEffect(() => {
    const routeChangeHandler = () => {
      // console.log('router.query.showRoomSetting', router.query.showRoomSetting);
      if (router.query.showRoomSetting === 'true') {
        setModalType(MODAL_TYPE.GAME_TYPE);
      }
    };
    router.events.on('routeChangeComplete', routeChangeHandler);

    return () => {
      router.events.off('routeChangeComplete', routeChangeHandler);
    };
  }, []);

  useEffect(() => {
    // Request geolocation permission on component mount
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        position => {
          // Successfully got permission, no need to do anything with the position
          console.log('Geolocation permission granted');
        },
        error => {
          console.log('Geolocation permission denied or error:', error.message);
        }
      );
    }
  }, []);

  const renderList = () => {
    // TODO @@ don not display if no announcement
    if (announcementList?.length === 0 || !announcementList) return <div>{t('menu:no_news')}</div>;

    return (
      <Tabs
        style={{height: '50vh'}}
        tabPosition="left"
        items={announcementList
          ?.filter(announcement => announcement?.active !== false)
          ?.sort(
            (announcementA, announcementB) => announcementA?.priority - announcementB?.priority
          )
          ?.map(announcement => {
            const {active, title, content, priority, from, to, id} = announcement;
            return {
              label: `${title}`,
              key: id,
              children: `${content}`,
            };
          })}
      />
    );
  };

  const closeRoomSettingDrawer = () => {
    setIsRoomSettingDrawerVisible(false);
  };

  const openRoomSettingDrawer = () => {
    setIsRoomSettingDrawerVisible(true);
  };

  const closeModals = () => {
    setModalType(null);
  };

  useEffect(() => {
    if (router.query.isDepositShown === 'true') {
      router.replace('/home', '/home'); // prevent popup after refresh
    }

    const handleReload = async () => {
      if (router.query.isReload === 'true') {
        await router.replace('/home', undefined, {shallow: true});
        window.location.reload();
      }
    };
    handleReload();

    lobbySocket.connect();

    return () => {
      lobbySocket.disconnect();
    };
  }, []);

  const {
    data: bannerList,
    loading: isBannerLoading,
    runAsync: getBannerList,
  } = useRequest(token => bannerApi.getBannerList(user?.getPlayerToken()), {
    onError: error => {
      message.error(error.message);
    },
  });

  // const {runAsync: updateFirstTimeLogin} = useRequest(
  //   token => userApi.updateFirstLogin(user.getPlayerToken()),
  //   {
  //     manual: true,
  //   }
  // );

  // const showFirstTimeLogin = async () => {
  //   setIsFirstTimeLoginVisible(true);
  //   try {
  //     await updateFirstTimeLogin(user.getPlayerToken());
  //     user.getPlayerInfo();
  //   } catch {
  //     console.error('update first-time login error: ');
  //   }
  // };

  // const closeFirstTimeLogin = () => {
  //   setIsFirstTimeLoginVisible(false);
  // };

  // useEffect(() => {
  //   if (playerInfo?.isFirstLogin) {
  //     showFirstTimeLogin();
  //   }
  // }, [playerInfo]);

  const renderBanners = () => {
    const minLength = 3;

    if (
      typeof bannerList === 'undefined' ||
      !bannerList ||
      !Array.isArray(bannerList) ||
      bannerList.length === 0
    ) {
      const banners = Array.from({length: minLength}, () => {
        return (
          // <img
          //   key="dummy"
          //   src="/images-mobile/home/dummy-banner.webp"
          //   alt="Banner"
          //   className={classes.carouselImage}
          // />
          null
        );
      });
      return banners;
    }

    let outputBanners = null;
    // * required by same, display the actual number of banners
    // if (bannerList.length < minLength) {
    if (false) {
      // fill the rest with repeated banners
      const repeatedBanners = Array.from({length: minLength - bannerList.length}, () => {
        return bannerList[0];
      });

      outputBanners = bannerList.concat(repeatedBanners);
    } else {
      outputBanners = bannerList;
    }

    return outputBanners
      .sort((a, b) => a?.priority - b?.priority)
      .map(({id, image, active, redirectUrl}) =>
        active ? (
          <Link className={classes.link} key={id} href={`${redirectUrl}`}>
            <img
              src={`${NEXT_PUBLIC_URL}${image}`}
              alt={`Banner-${id}`}
              className={classes.carouselImage}
            />
          </Link>
        ) : null
      );
  };

  useEffect(() => {
    if (!user || !user?.isLogin()) return;
    user?.getPlayerInfo();
    getAnnouncementList(user.getPlayerToken());
  }, [user]);

  useEffect(() => {
    // Only redirect after router is ready and we have query params
    if (!router.isReady) return;
    
    console.log('isTelegramMiniApp', isTelegramMiniApp, isMobile);
    console.log('Home page router.query:', router.query);
    
    if (isTelegramMiniApp || isMobile) {
      // Preserve ALL query parameters when redirecting
      console.log('Redirecting to telegram/game-list with query:', router.query);
      router.push({
        pathname: '/telegram/game-list',
        query: router.query,  // Keep all query parameters including 'inviteToRoom'
      });
    }
  }, [isTelegramMiniApp, isMobile, router.isReady, router.query]);

  const onLuckyDrawRemainderClose = () => {
    const notShowLuckyDrawReminderAgain = form.getFieldValue('notShowLuckyDrawReminderAgain');
    setIsLuckyDrawReminderVisible(false);
    if (notShowLuckyDrawReminderAgain) {
      localStorage.setItem(
        'notShowLuckyDrawReminderAgain',
        notShowLuckyDrawReminderAgain.toString()
      );
    }
  };

  const buttons = [
    {
      title: t('common:regular'),
      content: t('common:regular_description'),
      img: '/images-mobile/home/phaseTwo/long_card.webp',
      fn: () => {
        closeModals();
        setIsRoomSettingDrawerVisible(true);
        setGameTypeSelected('REGULAR');
        openRoomSettingDrawer();
      },
    },
    {
      title: t('common:short'),
      content: t('common:short_description'),
      img: '/images-mobile/home/phaseTwo/short_card.webp',
      fn: () => {
        closeModals();
        setIsRoomSettingDrawerVisible(true);
        setGameTypeSelected('SHORT');
        openRoomSettingDrawer();
      },
    },
    {
      title: t('common:omaha'),
      content: t('common:omaha_description'),
      img: '/images-mobile/home/phaseTwo/omaha.webp',
      fn: () => {
        closeModals();
        setIsRoomSettingDrawerVisible(true);
        setGameTypeSelected('OMAHA');
        openRoomSettingDrawer();
      },
    },
  ];
  return (
    <div>
      <Head>
        {/* // TODO @@ telegram */}
        {/* <script src="https://telegram.org/js/telegram-web-app.js?56"></script> */}
        <link
          rel="stylesheet"
          type="text/css"
          charSet="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
      </Head>
      <div className={classes.container}>
        <section className={classes.upperSection}>
          <section className={classes.sliderSection}>
            <Button
              size="small"
              className={classes.prevButton}
              onClick={() => {
                slider.current.slickPrev();
              }}
            >
              <img src="/images-mobile/home/left-arrow.svg" className={classes.arrowImage} alt="" />
            </Button>
            {isBannerLoading ? (
              <Skeleton key="dummy" animated style={{width: '100%', height: '30vh'}} />
            ) : (
              <Slider
                slidesPerRow={isDesktop ? 3 : 1}
                centered
                ref={slider}
                className={classes.slider}
                arrows={false}
                dots
              >
                {renderBanners()}
              </Slider>
            )}
            <Button
              size="small"
              className={classes.nextButton}
              onClick={() => {
                slider.current.slickNext();
              }}
            >
              <img
                src="/images-mobile/home/right-arrow.svg"
                className={classes.arrowImaghe}
                alt=""
              />
            </Button>
          </section>
        </section>

        <section className={classes.lowerSection}>
          {isDebugView && (
            <>
              <Button
                style={{color: 'black'}}
                onClick={() => {
                  user.appendJoinedRooms({
                    roomCode: Math.random().toString(),
                    roomType: 'PRIVATE',
                    gameType: 'REGULAR',
                    currencyId: 'coin',
                    isAllIn: false,
                    maxBuyIn: 2,
                    minBuyIn: 0.2,
                    smallBlind: 0.01,
                    bigBlind: 0.02,
                    actionTime: 10,
                    isObserver: true,
                  });
                  system?.setBubbleContent(
                    {
                      pot: 0,
                      hasAlert: false,
                      displayMode: 'POT',
                    },
                    user.joinedRooms?.length ?? 0
                  );
                }}
              >
                Append joined rooms
              </Button>
              <Button
                style={{color: 'black'}}
                onClick={() => {
                  user.appendJoinedRooms({
                    roomCode: Math.random().toString(),
                    roomType: 'PRIVATE',
                    gameType: 'OMAHA',
                    currencyId: 'coin',
                    isAllIn: false,
                    maxBuyIn: 2,
                    minBuyIn: 0.2,
                    smallBlind: 0.01,
                    bigBlind: 0.02,
                    actionTime: 10,
                    isObserver: true,
                  });
                  system?.setBubbleContent(
                    {
                      pot: 0,
                      hasAlert: false,
                      displayMode: 'POT',
                    },
                    user.joinedRooms?.length ?? 0
                  );
                }}
              >
                Append omaha joined rooms
              </Button>
              <Button
                style={{color: 'black'}}
                onClick={() => {
                  user.appendJoinedRooms({
                    roomCode: Math.random().toString(),
                    roomType: 'PRIVATE',
                    gameType: 'REGULAR',
                    currencyId: 'coin',
                    isAllIn: true,
                    maxBuyIn: 2,
                    minBuyIn: 0.2,
                    smallBlind: 0.01,
                    bigBlind: 0.02,
                    actionTime: 10,
                    isObserver: true,
                  });
                  system?.setBubbleContent(
                    {
                      pot: 0,
                      hasAlert: false,
                      displayMode: 'POT',
                    },
                    user.joinedRooms?.length ?? 0
                  );
                }}
              >
                Append ALL IN joined rooms
              </Button>
              <Button
                style={{color: 'black'}}
                onClick={() => {
                  user.appendJoinedRooms({
                    roomCode: Math.random().toString(),
                    roomType: 'PRIVATE',
                    gameType: 'OMAHA',
                    currencyId: 'coin',
                    isAllIn: true,
                    maxBuyIn: 2,
                    minBuyIn: 0.2,
                    smallBlind: 0.01,
                    bigBlind: 0.02,
                    actionTime: 10,
                    isObserver: true,
                  });
                  system?.setBubbleContent(
                    {
                      pot: 0,
                      hasAlert: false,
                      displayMode: 'POT',
                    },
                    user.joinedRooms?.length ?? 0
                  );
                }}
              >
                Append ALL IN Omaha joined rooms
              </Button>
              <Button
                style={{color: 'black'}}
                onClick={() => {
                  const roomCode = Math.random().toString();
                  user.appendJoinedRooms({
                    roomCode,
                    roomType: 'TOURNAMENT',
                    gameType: 'REGULAR',
                    currencyId: 'coin',
                    isAllIn: false,
                    maxBuyIn: 2,
                    minBuyIn: 0.2,
                    smallBlind: 0.01,
                    bigBlind: 0.02,
                    actionTime: 10,
                    isObserver: true,
                  });
                  setTimeout(() => {
                    const tabBubbleRef = getTabBubbleRefForRoom(roomCode);
                    console.log('tabBubbleRef', tabBubbleRef);
                    system.emitTournamentNotification(tabBubbleRef, roomCode);
                  }, 1000);
                }}
              >
                Append tournament room
              </Button>
              <Button
                style={{color: 'black'}}
                onClick={() => {
                  user.joinedRooms.forEach(({roomCode}) => {
                    user.removeJoinedRoom(roomCode);
                  });
                }}
              >
                Clear joined rooms
              </Button>
              <Button
                style={{background: 'grey'}}
                onClick={() => {
                  router.push('/telegram');
                }}
              >
                to telegram page
              </Button>
            </>
          )}
          <div className={classes.descriptionRow}>
            {/* <Button
              style={{background: 'black', color: 'white'}}
              onClick={() => {
                router.push('/telegram/game-list');
              }}
            >
              to tg game-list
            </Button> */}
            <div className={classes.myGameDescription}>{t('my_game')}</div>
            {/* <MainThemeButton className={classes.purpleButton}>{t('all_games')}</MainThemeButton>
             */}
            {/* <BlackButton
              onClickFunction={() => {
                router.push({
                  pathname: '/game-review',
                });
              }}
              iconPath="/images-mobile/home/game-record.webp"
              label={t('game_record')}
            /> */}

            <Button
              className={classes.gameRecordButton}
              style={{color: 'linear-gradient(90deg, #33C4E8 0%, #4A65F2 100%)'}}
              type="text"
              onClick={() => {
                if (!user?.isLogin()) {
                  system?.showModalSheet('login');
                } else {
                  router.push({
                    pathname: '/game-review',
                  });
                }
              }}
            >
              {t('game_record')}
              <img src="/icon/home/right-triangle.svg" alt="next" width="25" />
            </Button>
          </div>
          <Row className={classes.buttonsRow}>
            {/* // TODO @@ display it when game-demo is ready */}
            {/* <Col span={12} className={classes.squareButtonContainer}>
              <Button
                className={classes.squareButton}
                onClick={() => {
                  router.push({
                    pathname: '/game-list',
                    query: {gameType: GAME_MODE.REGULAR, currencyId: CURRENCIES.COIN},
                  });
                }}
              >
                <div className={classes.blackBorder}>
                  <div className={classes.innerBlackBorder}>
                    <img src="/icon/home/free-game.svg" alt="" width="30px" />
                  </div>
                </div>
              </Button>
              <div className={classes.buttonTextContainer}>
                <span>{t('free_game')}</span>
                <span style={{color: 'grey'}}>{t('play_without_money')}</span>
              </div>
            </Col> */}
            <Col span={12} className={classes.squareButtonContainer}>
              <Button
                className={classes.squareButton}
                onClick={() => {
                  if (user?.isLogin()) {
                    setModalType(MODAL_TYPE.CREATE_OR_ENTER);
                  } else {
                    system?.showModalSheet('login');
                  }
                }}
              >
                <div className={classes.blackBorder}>
                  <div className={classes.innerBlackBorder}>
                    <img src="/icon/home/private-game.svg" alt="" width="30px" />
                  </div>
                </div>
              </Button>
              <div className={classes.buttonTextContainer}>
                <span>{t('private_game')}</span>
                <span style={{color: 'grey'}}>{t('play_with_friends')}</span>
              </div>
            </Col>
          </Row>
          {/* <section className={classes.goldenButtonsSection}>
            <GoldenButton
              onClick={() => {
                setModalType(MODAL_TYPE.CREATE_OR_ENTER);
              }}
              label={t('join_private_room')}
              iconPath="/images-mobile/home/private-room-button.webp"
            />
          </section> */}
          <div className={classes.cardField}>
            <HomeCardItem
              id="gameModeRegular"
              backgroundPath={`${
                isDesktop
                  ? '/images-mobile/home/yellow-background-desktop.svg'
                  : '/images-mobile/home/yellow-background.webp'
              }`}
              image={
                <img
                  src="/images-mobile/home/phaseTwo/long_card.webp"
                  srcSet="/images-mobile/home/phaseTwo/long_card.webp"
                  alt=""
                />
              }
              cardName={t('common:regular')}
              content={t('regular_content')}
              handleClick={() => {
                router.push({
                  pathname: '/game-list',
                  query: {gameType: GAME_MODE.REGULAR, currencyId: CURRENCIES.COIN, isAllIn: false},
                });
              }}
            />
            <HomeCardItem
              id="gameModeRegularAllIn"
              backgroundPath={`${
                isDesktop
                  ? '/images-mobile/home/purple-background-desktop.webp'
                  : '/images-mobile/home/purple-background.webp'
              }`}
              image={
                <img
                  src="/images-mobile/home/phaseTwo/all_in.webp"
                  srcSet="/images-mobile/home/phaseTwo/all_in.webp"
                  alt=""
                />
              }
              cardName={t('common:all_in_game')}
              content={t('all_in_content')}
              handleClick={() => {
                router.push({
                  pathname: '/game-list',
                  query: {gameType: GAME_MODE.REGULAR, isAllIn: true, currencyId: CURRENCIES.COIN},
                });
              }}
            />
            <HomeCardItem
              id="gameModeOmahaAllIn"
              backgroundPath={`${
                isDesktop
                  ? '/images-mobile/home/purple-background-desktop.webp'
                  : '/images-mobile/home/purple-background.webp'
              }`}
              image={
                <img
                  src="/images-mobile/home/phaseTwo/all_in_omaha.webp"
                  srcSet="/images-mobile/home/phaseTwo/all_in_omaha.webp"
                  alt=""
                />
              }
              cardName={t('common:all_in_game_omaha')}
              content={t('omaha_all_in_content')}
              handleClick={() => {
                router.push({
                  pathname: '/game-list',
                  query: {gameType: GAME_MODE.OMAHA, isAllIn: true, currencyId: CURRENCIES.COIN},
                });
              }}
            />
            <HomeCardItem
              id="gameModeShort"
              backgroundPath={`${
                isDesktop
                  ? '/images-mobile/home/black-background-desktop.svg'
                  : '/images-mobile/home/black-background.webp'
              }`}
              // backgroundPath="/images-mobile/home/black-background.webp"
              image={
                <img
                  src="/images-mobile/home/phaseTwo/short_card.webp"
                  srcSet="/images-mobile/home/phaseTwo/short_card.webp"
                  alt=""
                />
              }
              cardName={t('common:short')}
              content={t('short_content')}
              handleClick={() => {
                router.push({
                  pathname: '/game-list',
                  query: {gameType: GAME_MODE.SHORT, currencyId: CURRENCIES.COIN, isAllIn: false},
                });
              }}
            />
            <HomeCardItem
              id="gameModeOmaha"
              backgroundPath={`${
                isDesktop
                  ? '/images-mobile/home/blue-background-desktop.webp'
                  : '/images-mobile/home/blue-background.webp'
              }`}
              image={
                <img
                  src="/images-mobile/home/phaseTwo/omaha.webp"
                  srcSet="/images-mobile/home/phaseTwo/omaha.webp"
                  alt=""
                />
              }
              cardName={t('common:omaha')}
              content={t('omaha_content')}
              handleClick={() => {
                router.push({
                  pathname: '/game-list',
                  query: {gameType: GAME_MODE.OMAHA, currencyId: CURRENCIES.COIN, isAllIn: false},
                });
              }}
            />
            <HomeCardItem
              backgroundPath={`${
                isDesktop
                  ? '/images-mobile/home/purple-background-desktop.webp'
                  : '/images-mobile/home/blue-background.webp'
              }`}
              image={
                <img
                  src="/images-mobile/home/phaseTwo/open_table.webp"
                  srcSet="/images-mobile/home/phaseTwo/open_table.webp"
                  alt=""
                />
              }
              cardName={t('common:start')}
              content={t('play_with_friends')}
              handleClick={() => {
                setModalType(MODAL_TYPE.CREATE_OR_ENTER);
              }}
            />
          </div>
        </section>
        <section style={{paddingBottom: 50, background: '#202633'}}>
          <div className={classes.playerStatistics}>
            <div className={classes.myGameDescription}> {t('player_statistics')}</div>
          </div>
          <LiveTable />
        </section>

        <div className={classes.firstTimeModalField}>
          {/* <CustomPopup
            width={280}
            bodyStyle={{textAlign: 'center'}}
            open={isFirstTimeLoginVisible}
            closable={false}
            buttons={[
              {
                buttonLabel: t('claim_first_time_reward_button'),
                buttonFunction: () => {
                  closeFirstTimeLogin();
                },
              },
            ]}
          >
            <div className={classes.modalImageDiv}>
              <img src="/images-mobile/game-room/coin.svg" alt="" />
            </div>
            <span className={classes.modalContent}>{t('first_time_login')}</span>
            <span className={classes.modalContent}>{t('first_time_reward_msg', {val: 10})}</span>
          </CustomPopup> */}

          {/* // TODO @@  */}

          <EnterRoomModalSheet
            buttons={buttons}
            isModalSheetOpen={modalType === MODAL_TYPE.CREATE_OR_ENTER}
            onModalSheetClose={() => setModalType(null)}
          />

          {/* <RoomSettingDrawer
            gameType={gameTypeSelected}
            closeDrawer={closeRoomSettingDrawer}
            open={isRoomSettingDrawerVisible}
            // visible
            height="89vh"
            openDrawerFromHome={openRoomSettingDrawer}
          /> */}
          <RoomSettingModalSheet
            openDrawerFromHome={openRoomSettingDrawer}
            gameType={gameTypeSelected}
            isModalSheetOpen={isRoomSettingDrawerVisible}
            onModalSheetClose={closeRoomSettingDrawer}
          />

          {/* <CustomPopup
            title={t('lucky_draw_reminder.title')}
            open={isLuckyDrawReminderVisible}
            closable
            onCancel={onLuckyDrawRemainderClose}
            footer={
              <>
                <GradientButton style={{height: 50}} onClick={form.submit}>
                  {t('common:confirm')}
                </GradientButton>
                <GradientButton
                  isBlue={false}
                  style={{height: 50}}
                  onClick={onLuckyDrawRemainderClose}
                >
                  {t('common:cancel')}
                </GradientButton>
              </>
            }
          >
            <Form
              form={form}
              onFinish={values => {
                if (values.notShowLuckyDrawReminderAgain) {
                  window.localStorage.setItem(`notShowLuckyDrawReminderAgain`, 'true');
                }
                router.push({
                  pathname: '/fortune-wheel',
                  query: router.query,
                });
                setIsLuckyDrawReminderVisible(false);
              }}
            >
              <p>{t('lucky_draw_reminder.message', {value: numOfDraws})}</p>

              <Form.Item name="notShowLuckyDrawReminderAgain" valuePropName="checked">
                <Checkbox style={{color: theme.secondaryTextColor}}>
                  {t('common:dont_show_again')}
                </Checkbox>
              </Form.Item>
            </Form>
          </CustomPopup> */}

          {/* {announcementList?.length !== 0 && (
            <NewCustomizedModal
              className={classes.announcementPopup}
              width={isDesktop ? '600px' : '85vw'}
              open={isAnnouncementVisible}
              closable
              onCancel={() => {
                setIsAnnouncementVisible(false);
              }}
              title={t('menu:announcement')}
            >
              {isAnnouncementLoading ? (
                <div className={classes.modalSpin}>
                  <Spin />
                </div>
              ) : (
                renderList()
              )}
            </NewCustomizedModal>
          )} */}
          {/* <NewCustomizedModal
            width={isDesktop ? '500px' : '85vw'}
            open={!system.isGameOverlayShown && isTimeDifferenceModalVisible}
            centered
            closable
            onCancel={() => {
              setIsTimeDifferenceModalVisible(false);
            }}
            title={t('notice')}
          >
            {t('time_difference_reminder')}
          </NewCustomizedModal> */}

          {/* <NewCustomizedModal
            width="300px"
            open={socket.isSameIPInSameRoom === true}
            centered
            title={t('notice')}
            isCloseButtonHidden
          >
            isSameDeviceLoggedIn
          </NewCustomizedModal> */}
          {/* <Button
            style={{background: 'grey'}}
            onClick={() => {
              router.push('/telegram');
            }}
          >
            to telegram page
          </Button>
          <Button
            style={{background: 'grey'}}
            onClick={() => {
              system?.setIsDebugMode(true);
            }}
          >
            debug mode
          </Button> */}
        </div>
      </div>
    </div>
  );
};

export default Home;
